import { Directive } from '@angular/core';
import { V2BasePageController } from './base-page.controller';
import { ContentMenuItem } from '../models';

@Directive()
export class V3DiscoverPageController extends V2BasePageController {
  protected grabRandomItems(
    items: ContentMenuItem[],
    count: number,
  ): ContentMenuItem[] {
    const chosen: ContentMenuItem[] = [];
    const chosenIndexes = this.randomIndexes(count, items.length);
    for (const i of chosenIndexes) {
      chosen.push(items[i]);
    }
    return chosen;
  }

  protected randomIndexes(needed: number, available: number): number[] {
    const chosen: number[] = [];
    if (available < needed) {
      for (let i = 0; i < available; i++) {
        chosen.push(i);
      }
    } else {
      while (chosen.length < needed) {
        const start = Math.floor(Math.random() * available);

        for (let i = 0; i < available; i++) {
          const id = (start + i) % available;
          if (!chosen.includes(id)) {
            chosen.push(id);
            break;
          }
        }
      }
    }
    return chosen;
  }
}
